import { render } from "./LoaderBlock.vue?vue&type=template&id=f0ff1aa8&scoped=true"
const script = {}

import "./LoaderBlock.vue?vue&type=style&index=0&id=f0ff1aa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0ff1aa8"]])

export default __exports__